import { SvgIcon, type SvgIconProps } from '../icons';

function SetLogoSmall(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width='448'
        height='448'
        viewBox='0 0 448 448'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.0820312 223.931C0.0820312 100.286 100.31 0.0576172 223.952 0.0576172C347.593 0.0576172 447.824 100.286 447.824 223.931C447.824 347.572 347.593 447.798 223.952 447.798C100.31 447.798 0.0820312 347.572 0.0820312 223.931Z'
          fill='white'
        />
        <path
          d='M223.913 437.14C338.584 437.14 432.105 346.597 436.891 233.103C436.886 233.106 418.138 233.11 418.138 233.11C408.82 233.11 403.562 238.465 401.422 244.897C392.053 282.824 357.801 310.945 316.98 310.945C281.819 310.945 251.531 290.08 237.821 260.056C228.016 241.214 208.531 233.11 190.16 233.11H10.9365C15.7245 346.599 109.244 437.14 223.913 437.14Z'
          fill='#231F20'
        />
        <path
          d='M223.914 10.7927C109.242 10.7927 15.7233 101.335 10.9365 214.83C10.9417 214.828 29.69 214.822 29.69 214.822C39.0082 214.822 44.266 209.468 46.4057 203.035C55.7748 165.109 90.0272 136.988 130.848 136.988C166.009 136.988 196.297 157.853 210.006 187.877C219.812 206.717 239.297 214.822 257.667 214.822H436.892C432.102 101.334 338.583 10.7927 223.914 10.7927Z'
          fill='#FCB033'
        />
      </svg>
    </SvgIcon>
  );
}

export default SetLogoSmall;
export { SetLogoSmall };
